function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M10.6888 14.4316L6.15196 11.3895C6.3085 10.9978 6.38437 10.5791 6.37508 10.1579C6.3762 9.73544 6.29316 9.31691 6.13071 8.92632L11.4963 5.32632C11.9346 5.78559 12.5019 6.10401 13.1248 6.24039C13.7478 6.37676 14.3977 6.3248 14.9905 6.09124C15.5833 5.85769 16.0917 5.45327 16.45 4.93032C16.8082 4.40736 16.9999 3.78993 17.0001 3.15789C17.0001 2.32037 16.6643 1.51715 16.0665 0.924926C15.4687 0.332706 14.658 0 13.8126 0C12.9672 0 12.1565 0.332706 11.5587 0.924926C10.9609 1.51715 10.6251 2.32037 10.6251 3.15789C10.6272 3.60472 10.7249 4.04602 10.912 4.45263L5.59946 8.04211C5.16909 7.56541 4.60277 7.22941 3.97543 7.07857C3.3481 6.92772 2.68932 6.96914 2.08626 7.19735C1.48321 7.42556 0.964309 7.82979 0.598226 8.35656C0.232143 8.88334 0.0361328 9.50782 0.0361328 10.1474C0.0361328 10.7869 0.232143 11.4114 0.598226 11.9382C0.964309 12.4649 1.48321 12.8692 2.08626 13.0974C2.68932 13.3256 3.3481 13.367 3.97543 13.2162C4.60277 13.0653 5.16909 12.7293 5.59946 12.2526L10.1151 15.2737C10.2691 14.9698 10.462 14.6868 10.6888 14.4316Z",
  fill: "white"
}), React.createElement("path", {
  d: "M13.8232 20.4105C15.5836 20.4105 17.0107 18.9967 17.0107 17.2526C17.0107 15.5086 15.5836 14.0947 13.8232 14.0947C12.0628 14.0947 10.6357 15.5086 10.6357 17.2526C10.6357 18.9967 12.0628 20.4105 13.8232 20.4105Z",
  fill: "white"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 17.0106,
  height: 20.4105,
  fill: "white"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/link.26cd980f.svg";
export { SvgComponent as ReactComponent };